var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "payment-promise-full-screen-modal",
      attrs: {
        id: "annonce-payment-promise-modal",
        "header-class": "payment-promise-modal-header",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass:
                    "payment-promise-modal-header-content step4 w-100"
                },
                [
                  _c("img", {
                    staticClass: "payment-promise-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-watcher-right.png")
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "payment-promise-container h-100" },
                    [
                      _c("h1", {
                        staticClass:
                          "page-title mt-4 ml-4 payment-promise-modal-subtitle",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.isRewardEdit
                              ? _vm.$t("payment.validation.edit.title")
                              : _vm.$t("payment.validation.publish.title")
                          )
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-4",
                      attrs: { variant: "secondary" },
                      on: { click: _vm.handleCancel }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Back")))]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary", disabled: !_vm.isChecked },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isRewardEdit
                                    ? _vm.$t("Validate")
                                    : _vm.$t("Publish")
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "d-flex mb-4" },
          [
            _c("b-form-checkbox", {
              staticClass: "mr-2",
              attrs: { id: "confirmationChecked" },
              model: {
                value: _vm.isChecked,
                callback: function($$v) {
                  _vm.isChecked = $$v
                },
                expression: "isChecked"
              }
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("payment.validation.content"))
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("p", {
          staticClass: "main-grey-medium-color",
          domProps: {
            innerHTML: _vm._s(_vm.$t("payment.validation.explanation"))
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3072e86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3072e86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnoncePaymentPromiseModal.vue
// module id = HYuC
// module chunks = 0